import { useState, useEffect } from 'react';
import { Tabs, Space } from 'antd';
import Table from '../../../TableResizable';
import type { TabsProps } from 'antd';
import { Button, Form, Spin } from 'antd';
import { UserOutlined, ContactsOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import axios from 'axios';
import { color } from '@mui/system';
import Tab1 from './Tab1';
import { Print, Save, SwipeUp, ViewAgenda, ViewColumn } from '@mui/icons-material';
import Utilisateur from '../../../../Models/Utilisateur';
import { useAuthHeader, useAuthUser } from '../../../../Services/Auth/sessionAuth';
import Data from '../../../../Data/Data.json'
import SweetAlert from "sweetalert2"
import { Crypter } from '../../../../Functions/Security/Crypter';
import { Box, Typography, styled } from '@mui/material';
import { ColumnsType } from 'antd/es/table';
import InputForm from '../../../InputT';
import Tab2 from './Tab2';
import Amortissement from '../../../../Functions/Traitement/Amortissement';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import formatDate from '../../../../Functions/Traitement/fomatDate';
import Pret from '../../../../Models/Pret';
import ReformatDate from '../../../../Functions/Traitement/ReformatDate';
import Tab3 from './Tab3';
import ParamsPicklist from '../../../../Types/ParamsPicklist';
import Datas from "../../../../Data/Data.json"
import Garantie from '../../../../Models/Garantie';
import RELATION from '../../../../Models/Relation';
import formatNumber from '../../../../Functions/Traitement/FormatNumber';
import Operation from '../../../../Models/Operation';
import ReformatNumber from '../../../../Functions/Traitement/ReformatNumber';
import OperationCaisse from '../../../../Models/OperationCaisse';
import ReceptionAgent from './ReceptionAgent';
import formatOrderDate from '../../../../Functions/Traitement/formatOrderDate';
import { apiEndpoints } from '../../../../config';
import { formatCurrency, getField, PrintRecuCaisseDirect } from '../../../../utilitaires/globalFunction';
import { LoadBilletage } from '../../../../Functions/Traitement/LoadBilletage';
//import "../../Assets/Styles/StyleForm.css";



//CreateNewCLIENT
//const Swal = require('sweetalert2');
//let LinkSourceApi= require('../../Data/Data.json');

const VersementEspece = () => {
  // USER SESSION
  const auth = useAuthUser()
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()))

  // USER TOKEN
  const authHeader = useAuthHeader()

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [StartSearchG, SeStartSearchG] = useState(false);
  const [StartForm, SetStartForm] = useState(true);
  const [, forceUpdate] = useState({});
  const [isSubmit, setIsSubmit] = useState(false)
  const [ajoutActve, setAjoutActif] = useState(false)
  const [modifActve, setModifActve] = useState(true)
  const [enregActve, setEnregActve] = useState(false)
  const [supActive, setSupActive] = useState(true)
  const [impActive, setImpActive] = useState(true)
  const [actuActive, setActActive] = useState(true)
  const [annulActive, setAnnulActive] = useState(true)
  const [consulActive, setConsulActive] = useState(false)
  const [pageLoad, setPageLoad] = useState(true)
  const [sbmit, setSbmit] = useState("")
  const [data, setData] = useState<Pret[]>([])
  const navigate = useNavigate()
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [radioaCheck, setRadioaCheck] = useState(false)
  const [recep, setRecep] = useState(false)
  const [codeOpe, setCodeOpe] = useState("")
  const [codeSecret, setCodeSecret] = useState("")
  const [dataOpe, setDataOpe] = useState<any>({})


  type ExportFormat = keyof typeof mimeTypes; // 'pdf' | 'xlsx' | 'docx' | 'html' | ...

  const mimeTypes = {
    pdf: "application/pdf",
    xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    html: "text/html",
    csv: "text/csv",
    txt: "text/plain",
    json: "application/json",
    png: "image/png",
    jpeg: "image/jpeg"
  } as const;

  const SetStart = () => {
    setSbmit("add")
    setAjoutActif(true)
    setEnregActve(false)
    setAnnulActive(false)
    setConsulActive(true)
    //form.resetFields()
  }

  try {
    let localData = JSON.parse(localStorage.getItem(Data.LocalVariable.tabAmort) + "")
    form.setFieldsValue((localData.form))

  } catch (error) {

  }


  useEffect(() => {
    forceUpdate({});
  }, []);

  function initialiazeButton() {
    setAjoutActif(false)
    setModifActve(true)
    setEnregActve(false)
    setSupActive(true)
    setImpActive(true)
    setActActive(true)
    setAnnulActive(true)
    setConsulActive(false)
    setRecep(false)
  }



  const SetEndStart = () => {
    SetStartForm(true);
    SeStartSearchG(false)
  }
  function handleAnulle() {
    let so = form.getFieldValue("CODOPE")
    let numCaisse = form.getFieldValue("NODECE")
    let caiUti = form.getFieldValue("CAIUTI")

    let CODAGE = user.codage
    let lib_CODAGE = user.agence

    setRadioaCheck(false)
    setImpActive(true)
    //setData([])
    form.resetFields()
    localStorage.clear()
    initialiazeButton()
    localStorage.setItem(Data.LocalVariable.reset, "1")
    localStorage.setItem(Data.LocalVariable.Mainreset, "1")
    localStorage.setItem(Data.LocalVariable.resetTable, "1")
    form.setFieldValue("CODOPE", so)
    form.setFieldValue("NODECE", numCaisse)
    form.setFieldValue("CODOPE", "");
    form.setFieldValue("CAIUTI", caiUti);

    form.setFieldValue("CODAGE", CODAGE.trim());
    form.setFieldValue("lib_CODAGE", lib_CODAGE);
    form.setFieldValue("Billetages", "");
  }
  function cunsultButton() {
    setAnnulActive(false)
    setModifActve(false)
  }

  function modifButton() {
    setRadioaCheck(true)
    setSbmit("update")
    setModifActve(true)
    setAjoutActif(true)
    setEnregActve(false)
    setConsulActive(true)
  }


  const items: TabsProps['items'] = [

    {
      key: '1',
      label: (
        <span id='Tab'>
          <UserOutlined />
          Détail Opération
        </span>
      ),
      children: <Tab1 form={form} />, //form={form}
    },
    {
      key: '2',
      label: (
        <span id='Tab'>
          <UserOutlined />
          Billetage
        </span>
      ),
      children: <Tab3 form={form} />, //form={form}
    },
    {
      key: '3',
      label: (
        <span id='Tab'>
          <UserOutlined />
          Opérations en attente de confirmation
        </span>
      ),
      children: <Tab2 form={form} />, //form={form}
    },
  ];

  const affiche = () => {
    let values: any = form.getFieldsValue()
    localStorage.clear()

    setImpActive(false)

    let Amort: Amortissement = new Amortissement(values.NUMCLI, values.PERIODIC, values.MONTEPARG, values.TAUXINT, values.NBPERDIF, values.TYPEPRET, values.TYPAMORT, values.TAUXEPAR, values.NBRECHE, values.MONTAN, values.TYPCALC, values.TAUXTAX, values.DAT1ECHE, values.cssionApliq)
    console.log(Amort)

    setData(Amort.GetAmortissement() as [])

    form.setFieldsValue(Amortissement.totaux)

  };


  const onFinishFailed = async (errorInfo: any) => {
    var errors: any = [];

    errorInfo.errorFields.map((error: any) => {

      errors.push(error.name + "");
    })

    SweetAlert.fire({ title: "Veuillez remplir tous les champs obligatoires", text: errors.toString().replaceAll(',', " - "), icon: 'warning', confirmButtonText: 'OK' })

  };


  function printTab() {

    loadAccountInformations(dataOpe.NUMCPT)

    localStorage.setItem(Data.LocalVariable.Recu, JSON.stringify({ "form": dataOpe }))

    //navigate("/operation/Deposit&withdrawal/print")
    navigate("/caisse/veresmentretrait/print")
  }

  function printTab2() {

    loadAccountInformations(dataOpe.NUMCPT)

    localStorage.setItem(Data.LocalVariable.Recu, JSON.stringify({ "form": dataOpe }))

    //navigate("/operation/Deposit&withdrawal/print")
    navigate("/caisse/veresmentretrait/print")
  }


  const handleDownloadRecu = async (format: string = "pdf") => {
    try {

      //setLoading(true);
      let Nodece = form.getFieldValue("NODECE");
      let NumSeq = form.getFieldValue("NUMSEQ");
      let UtiSai = form.getFieldValue("UTISAI");
      let CodAgce = user?.codage || "";
      let Libelle = user.agence;
      let NomUser = user?.nomuti || "";
      let SensOpe = form.getFieldValue("lib_CODOPE") || "";
      let Devise = form.getFieldValue("lib_CDDEVS") || "XAF";
      let LibInfos = form.getFieldValue("CODOPE1") || "";
      let NumCpt = form.getFieldValue("NUMCPT") || ""
      let Montan = formatCurrency(form.getFieldValue("montantOpe") ?? "0", form.getFieldValue("CDDEVS") || "XAF")
      let LibDevise = Devise

      //alert(Montan)


      if (LibInfos == "950" || LibInfos == "050") {
        SensOpe = "VERSEMENT ESPECES"
        LibInfos = "Nous portons au crédit du compte: " + NumCpt + " la somme de :" + Montan + " " + Devise;
      }
      if (LibInfos == "951" || LibInfos == "051") {
        SensOpe = "RETRAIT ESPECES"
        LibInfos = "Nous portons au débit du compte: " + NumCpt + " la somme de :" + Montan + " " + Devise;
      }





      const op: OperationCaisse = form.getFieldsValue();
      // console.log(op)
      // op.DISPON = ReformatNumber(form.getFieldValue("DISPON") ?? "0");
      // op.NODECE = form.getFieldValue("NODECE");
      // op.UTISAI = form.getFieldValue("UTISAI");
      // op.CODAGE = form.getFieldValue("CODAGE");
      // op.NUMSEQ = form.getFieldValue("NUMRAP");

      const response = await axios.get(`${apiEndpoints.fastReport}/PrintRecuCaisse`, {
        params: {
          CodAgce, Libelle, Nodece, NumSeq, UtiSai, NomUser, SensOpe, LibDevise, LibInfos
        },
        responseType: 'blob',
      });

      if (response.data) {
        // alert( response.data);
        const blob = new Blob([response.data], { type: "application/pdf" });
        const now = new Date();
        const formattedDate = now.toLocaleDateString("fr-FR").replace(/\//g, "-");
        const formattedTime = now.toLocaleTimeString("fr-FR").replace(/:/g, "-"); // remplace ":" pour éviter les problèmes de nom de fichier
        const fileName = `PrintRecuCaisse_${NumSeq}_${UtiSai}_${formattedDate}_${formattedTime}.${format}`;

        //const fileName = `PrintRecuCaisse_${NumSeq}_${UtiSai}_${new Date().toLocaleTimeString("fr-FR").replace(/\//g, "-")}.${format}`;
        // const url = window.URL.createObjectURL(blob);
        // const link = document.createElement("a");
        // link.href = url;
        // link.setAttribute("download", fileName);
        // document.body.appendChild(link);
        // link.click();
        // document.body.removeChild(link);
        // window.URL.revokeObjectURL(url);

        //       const file = new File([blob], fileName, { type: "application/pdf" });
        //       const url = URL.createObjectURL(file);
        //       const previewHtml = `
        //   <html>
        //     <head>
        //       <title>${fileName}</title>
        //     </head>
        //     <body style="margin:0">
        //       <iframe src="${url}" width="100%" height="100%" style="border:none;"></iframe>
        //     </body>
        //   </html>
        // `;

        // const previewBlob = new Blob([previewHtml], { type: "text/html" });
        // const previewUrl = URL.createObjectURL(previewBlob);
        // window.open(previewUrl, '_blank');
        //window.open(url, '_blank');

        //const url = window.URL.createObjectURL(blob);
        //window.open(url, '_blank'); // Ouvre le PDF dans un nouvel onglet pour prévisualisation
        const url = window.URL.createObjectURL(blob);
        //       SweetAlert.fire({
        //   title: "Reçu généré",
        //   text: "Souhaitez-vous prévisualiser ou télécharger le reçu ?",
        //   icon: "question",
        //   showCancelButton: true,
        //   confirmButtonText: "Prévisualiser",
        //   cancelButtonText: "Télécharger"
        // }).then((result) => {

        //   if (result.isConfirmed) {
        //     window.open(url, '_blank'); // Prévisualisation
        //   } else {
        //     const link = document.createElement("a");
        //     link.href = url;
        //     link.setAttribute("download", fileName);
        //     document.body.appendChild(link);
        //     link.click();
        //     document.body.removeChild(link);
        //     window.URL.revokeObjectURL(url);

        //   }
        // });

        //   setTimeout(() => {
        //       window.URL.revokeObjectURL(url);
        //       }, 10000);     

        SweetAlert.fire({
          title: "Reçu généré",
          text: "Souhaitez-vous prévisualiser, imprimer ou télécharger le reçu ?",
          icon: "question",
          showCancelButton: true,
          showDenyButton: true,
          denyButtonText: "Imprimer",
          confirmButtonText: "Prévisualiser",
          cancelButtonText: "Télécharger"
        }).then((result) => {
          const file = new File([blob], fileName, { type: "application/pdf" });
          const url = URL.createObjectURL(file);

          if (result.isConfirmed) {
            // ✅ Prévisualiser
            window.open(url, '_blank');
          } else if (result.isDenied) {
            // ✅ Imprimer directement via iframe
            const printHtml = `
      <html>
        <head>
          <title>${fileName}</title>
          <style>
            html, body {
              margin: 0;
              height: 100%;
            }
            iframe {
              width: 100%;
              height: 100%;
              border: none;
            }
          </style>
        </head>
        <body>
          <iframe id="pdfFrame" src="${url}"></iframe>
          <script>
            const iframe = document.getElementById('pdfFrame');
            iframe.onload = function() {
              setTimeout(() => {
                iframe.contentWindow.focus();
                iframe.contentWindow.print();
              }, 500);
            };
          </script>
        </body>
      </html>
    `;
            const printBlob = new Blob([printHtml], { type: "text/html" });
            const printUrl = URL.createObjectURL(printBlob);
            window.open(printUrl, '_blank');
          } else {
            // ✅ Télécharger
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }

          // Nettoyage après quelques secondes
          setTimeout(() => {
            URL.revokeObjectURL(url);
          }, 10000);
        });

      } else {
        SweetAlert.fire({ title: "Erreur", text: String("Erreur lors du téléchargement du fichier :"), icon: "error" });
      }

      // setLoading(false);

    } catch (error) {
      // setLoading(false);
      console.error("Erreur lors du téléchargement du fichier :", error);
      SweetAlert.fire({ title: "Erreur", text: String(error), icon: "error" });
    }
  };

  const handleDownloadRecuDirect = async (Nodece: string, NumSeq: string, UtiSai: string, SensOpe: string, Devise: string, LibDevise: string, LibInfos: string, NumCpt: string, montantOpe: number, CDDEVS: string, format: string = "pdf") => {
    try {

      //setLoading(true);
      // let Nodece = form.getFieldValue("NODECE");
      // let NumSeq = form.getFieldValue("NUMSEQ");
      // let UtiSai = form.getFieldValue("UTISAI");
      let CodAgce = user?.codage || "";
      let Libelle = user.agence;
      let NomUser = user?.nomuti || "";
      // let SensOpe = form.getFieldValue("lib_CODOPE") || "";
      // let Devise = form.getFieldValue("lib_CDDEVS") || "XAF";
      // let LibInfos = form.getFieldValue("CODOPE1") || "";
      // let NumCpt=form.getFieldValue("NUMCPT") || ""
      let Montan = formatCurrency(montantOpe, Devise)//formatCurrency (form.getFieldValue("montantOpe") ?? "0",form.getFieldValue("CDDEVS") || "XAF")


      //alert(Montan)


      if (LibInfos == "950" || LibInfos == "050") {
        SensOpe = "VERSEMENT ESPECES"
        LibInfos = "Nous portons au crédit du compte: " + NumCpt + " la somme de :" + Montan + " " + LibDevise;
      }
      if (LibInfos == "951" || LibInfos == "051") {
        SensOpe = "RETRAIT ESPECES"
        LibInfos = "Nous portons au débit du compte: " + NumCpt + " la somme de :" + Montan + " " + LibDevise;
      }

      if (LibInfos == "955") {
        SensOpe = "ENVOI D'ARGENT ESPECES"
        LibInfos = "Nous portons au crédit du compte: " + NumCpt + " la somme de :" + Montan + " " + LibDevise;
      }





      // const op: OperationCaisse = form.getFieldsValue();
      // console.log(op)
      // op.DISPON = ReformatNumber(form.getFieldValue("DISPON") ?? "0");
      // op.NODECE = form.getFieldValue("NODECE");
      // op.UTISAI = form.getFieldValue("UTISAI");
      // op.CODAGE = form.getFieldValue("CODAGE");
      // op.NUMSEQ = form.getFieldValue("NUMRAP");

      const response = await axios.get(`${apiEndpoints.fastReport}/PrintRecuCaisse`, {
        params: {
          CodAgce, Libelle, Nodece, NumSeq, UtiSai, NomUser, SensOpe, LibDevise, LibInfos
        },
        responseType: 'blob',
      });

      if (response.data) {
        // alert( response.data);
        const blob = new Blob([response.data], { type: "application/pdf" });
        const now = new Date();
        const formattedDate = now.toLocaleDateString("fr-FR").replace(/\//g, "-");
        const formattedTime = now.toLocaleTimeString("fr-FR").replace(/:/g, "-"); // remplace ":" pour éviter les problèmes de nom de fichier
        const fileName = `PrintRecuCaisse_${NumSeq}_${UtiSai}_${formattedDate}_${formattedTime}.${format}`;

        //const fileName = `PrintRecuCaisse_${NumSeq}_${UtiSai}_${new Date().toLocaleTimeString("fr-FR").replace(/\//g, "-")}.${format}`;
        // const url = window.URL.createObjectURL(blob);
        // const link = document.createElement("a");
        // link.href = url;
        // link.setAttribute("download", fileName);
        // document.body.appendChild(link);
        // link.click();
        // document.body.removeChild(link);
        // window.URL.revokeObjectURL(url);

        //       const file = new File([blob], fileName, { type: "application/pdf" });
        //       const url = URL.createObjectURL(file);
        //       const previewHtml = `
        //   <html>
        //     <head>
        //       <title>${fileName}</title>
        //     </head>
        //     <body style="margin:0">
        //       <iframe src="${url}" width="100%" height="100%" style="border:none;"></iframe>
        //     </body>
        //   </html>
        // `;

        // const previewBlob = new Blob([previewHtml], { type: "text/html" });
        // const previewUrl = URL.createObjectURL(previewBlob);
        // window.open(previewUrl, '_blank');
        //window.open(url, '_blank');

        //const url = window.URL.createObjectURL(blob);
        //window.open(url, '_blank'); // Ouvre le PDF dans un nouvel onglet pour prévisualisation
        const url = window.URL.createObjectURL(blob);
        //       SweetAlert.fire({
        //   title: "Reçu généré",
        //   text: "Souhaitez-vous prévisualiser ou télécharger le reçu ?",
        //   icon: "question",
        //   showCancelButton: true,
        //   confirmButtonText: "Prévisualiser",
        //   cancelButtonText: "Télécharger"
        // }).then((result) => {

        //   if (result.isConfirmed) {
        //     window.open(url, '_blank'); // Prévisualisation
        //   } else {
        //     const link = document.createElement("a");
        //     link.href = url;
        //     link.setAttribute("download", fileName);
        //     document.body.appendChild(link);
        //     link.click();
        //     document.body.removeChild(link);
        //     window.URL.revokeObjectURL(url);

        //   }
        // });

        //   setTimeout(() => {
        //       window.URL.revokeObjectURL(url);
        //       }, 10000);     

        SweetAlert.fire({
          title: "Reçu généré",
          text: "Souhaitez-vous prévisualiser, imprimer ou télécharger le reçu ?",
          icon: "question",
          showCancelButton: true,
          showDenyButton: true,
          denyButtonText: "Imprimer",
          confirmButtonText: "Prévisualiser",
          cancelButtonText: "Télécharger"
        }).then((result) => {
          const file = new File([blob], fileName, { type: "application/pdf" });
          const url = URL.createObjectURL(file);

          if (result.isConfirmed) {
            // ✅ Prévisualiser
            window.open(url, '_blank');
          } else if (result.isDenied) {
            // ✅ Imprimer directement via iframe
            const printHtml = `
      <html>
        <head>
          <title>${fileName}</title>
          <style>
            html, body {
              margin: 0;
              height: 100%;
            }
            iframe {
              width: 100%;
              height: 100%;
              border: none;
            }
          </style>
        </head>
        <body>
          <iframe id="pdfFrame" src="${url}"></iframe>
          <script>
            const iframe = document.getElementById('pdfFrame');
            iframe.onload = function() {
              setTimeout(() => {
                iframe.contentWindow.focus();
                iframe.contentWindow.print();
              }, 500);
            };
          </script>
        </body>
      </html>
    `;
            const printBlob = new Blob([printHtml], { type: "text/html" });
            const printUrl = URL.createObjectURL(printBlob);
            window.open(printUrl, '_blank');
          } else {
            // ✅ Télécharger
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }

          // Nettoyage après quelques secondes
          setTimeout(() => {
            URL.revokeObjectURL(url);
          }, 10000);
        });

      } else {
        SweetAlert.fire({ title: "Erreur", text: String("Erreur lors du téléchargement du fichier :"), icon: "error" });
      }

      // setLoading(false);

    } catch (error) {
      // setLoading(false);
      console.error("Erreur lors du téléchargement du fichier :", error);
      SweetAlert.fire({ title: "Erreur", text: String(error), icon: "error" });
    }
  };

  const onFinish = (values: any) => {

    (async () => {
      values.CODAGE = await getField("COMPTES", "NUMCPT", "AGCCPT", user.codage, user.codage, form.getFieldValue("NUMCPT"))
      // console.log("Libelle :", libelle);
    })();

    values.AGCEDEPART = user.codage
    // values.CODAGE =  getField("COMPTES","NUMCPT","AGCCPT",user.codage,user.codage,form.getFieldValue("NUMCPT"))

    //alert(values.CODAGE)

    if (form.getFieldValue("CODAGE").trim() == user.codage.trim() || form.getFieldValue("CODAGE") == "" || form.getFieldValue("CODAGE") == undefined) {
      values.CODOPE = values.CODOPE.split('|')[0]
    } else {
      values.CODOPE = values.CODOPE.split('|')[1]
    }

    try {
      if (values.montantOpe == ReformatNumber(form.getFieldValue("TotalBilletage"))) {
        var op: OperationCaisse = values

        op.Billetages = form.getFieldValue("Billetages")
        op.TypeOpe = form.getFieldValue("TypeOpe")
        op.NODECE = form.getFieldValue("NODECE")
        op.CAIUTI = form.getFieldValue("CAIUTI")
        op.UTISAI = user.coduti
        op.DateDeliv = formatDate(op.DateDeliv)
        //op.DateOpe = formatDate(op.DateOpe)
        op.DateVal = formatDate(op.DateVal)
        op.DISPON = ReformatNumber(form.getFieldValue("DISPON") ? form.getFieldValue("DISPON") : "0")
        op.DateOpe = formatDate(formatOrderDate(user.datjour)) //formatOrderDate((new Date(Date.now())).toLocaleDateString())
        let value = op.TypeOpe

        //alert(op.DateOpe)

        // alert(JSON.stringify(op.Billetages))
        SweetAlert.fire({
          title: ((value == 'VER') ? "VERSEMENT" : (value == 'RET') ? "RETRAIT" : (value == 'ENV') ? "ENVOI D'ARGENT" : "RECEPTION D'ARGENT ") + " " + " de " + formatNumber(parseInt(op.montantOpe)) + " XAF\nPar " + op.nomClient + "\nCompte : \n" + op.NUMCPT + ' (' + op.lib_NUMCPT + ')',
          showCancelButton: true,
          color: "green",
          confirmButtonText: "Yes",
          confirmButtonColor: "green",
          cancelButtonColor: "darkred",
          cancelButtonText: "No",
          showLoaderOnConfirm: true,
          icon: 'question'
        }).then((res) => {
          if (res.isConfirmed) {
            try {

              setLoading(true);
              setIsSubmit(true)

              let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: Data.ApiUrl.OperationsCaisse,
                headers: {
                  'Authorization': authHeader(),
                  'Content-Type': 'application/json'
                },
                data: Crypter.encrypt(JSON.stringify(op)),
              };

              axios.request(config)
                .then((response) => {
                  setLoading(false);
                  if (response.data) {
                    const res = JSON.parse(Crypter.decrypt(response.data)).Value;
                    //alert(res.StatutCode)
                    if (res.StatutCode == 200) {
                      handleAnulle()
                      setIsSubmit(false)
                      SweetAlert.fire({ title: res.Message, icon: "success" })
                      initialiazeButton()
                      localStorage.setItem(Data.LocalVariable.reset, "1")
                      initialiazeButton()
                      setSbmit("")

                      //Impression Recu
                      op.NUMSEQ = res.Message.split(" : ")[1]
                      op.CODAGE = user.codage
                      let data = { "form": op }
                      localStorage.setItem(Data.LocalVariable.Recu, JSON.stringify(data))
                      //navigate("/operation/Deposit&withdrawal/print")
                      // navigate("/caisse/veresmentretrait/print")
                      // alert("test confirmation")
                      //handleDownloadRecuDirect(op.NODECE,op.NUMSEQ,op.UTISAI,op.lib_CODOPE,op.CDDEVS,op.lib_CDDEVS,op.CODOPE1,op.NUMCPT,Number(op.montantOpe),op.CDDEVS,"pdf")
                      PrintRecuCaisseDirect(user.codage, user.agence, user.nomuti, op.NODECE, op.NUMSEQ, op.UTISAI, op.lib_CODOPE, op.CDDEVS, op.lib_CDDEVS, op.CODOPE1, op.NUMCPT, Number(op.montantOpe), "pdf")

                    }
                    else if (res.StatutCode == 208) {
                      //alert(JSON.stringify(res.Result.Table1))
                      var UsersVal: { [name: string]: string } = {};

                      res.Result.Table1.map((u: any) => {
                        UsersVal[u.CODUTI] = u.CODUTI + " - " + u.NOMUTI
                      })
                      SweetAlert.fire({
                        title: res.Message,
                        text: "Voulez vous passez cette opération en litige?",
                        showCancelButton: true,
                        color: "green",
                        confirmButtonText: "Yes",
                        confirmButtonColor: "green",
                        cancelButtonColor: "darkred",
                        cancelButtonText: "No",
                        showLoaderOnConfirm: true,
                        input: 'select',
                        inputOptions: UsersVal,
                        inputPlaceholder: "Utilisateur qui dois valider l'opération",
                        icon: 'warning'
                      }).then((resp) => {

                        if (resp.isConfirmed) {
                          if (resp.value != null && resp.value != "") {
                            op.utival = resp.value
                            op.lib_CODOPE = op.lib_CODOPE + '|' + res.Message;
                            op.CODAGE = user.codage
                            SendToLitige(op)
                          } else {
                            SweetAlert.fire({ title: "Veillez sélectionner l'utilisateur qui doit valider l'opération", icon: "warning" })
                          }
                        }
                      }).catch((error) => {
                        setLoading(false);
                        console.log(error)
                        SweetAlert.fire({ title: error, icon: "error" })
                      })
                    }
                    else {
                      SweetAlert.fire({ title: res.Message, icon: "warning" })
                    }
                  }
                })
                .catch((error) => {
                  setLoading(false);
                  console.log(error)
                  SweetAlert.fire({ title: error, icon: "error" })
                })

            } catch (error) {
              SweetAlert.fire({ title: 'Error ocured while getting warranties or avalistes', icon: "error" })
            }
          }
        })
      } else {
        SweetAlert.fire({ title: 'Votre Bielletage est incorrect', icon: "warning" })
      }
    } catch (error) {
      //alert("test ooo")
      SweetAlert.fire({ title: 'Veillez renseigner le billetage', icon: "warning" })
    }
  };

  function SendToLitige(op: OperationCaisse) {
    try {
      setLoading(true);
      setIsSubmit(true)

      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: Data.ApiUrl.SendToLitige,
        headers: {
          'Authorization': authHeader(),
          'Content-Type': 'application/json'
        },
        data: Crypter.encrypt(JSON.stringify(op)),
      };

      axios.request(config)
        .then((response) => {
          setLoading(false);
          if (response.data) {
            const res = JSON.parse(Crypter.decrypt(response.data)).Value;

            if (res.StatutCode == 200) {
              handleAnulle()
              setIsSubmit(false)
              SweetAlert.fire({ title: res.Message, icon: "success" })
              initialiazeButton()
              localStorage.setItem(Data.LocalVariable.reset, "1")
              initialiazeButton()
              setSbmit("")

            }
            else {
              SweetAlert.fire({ title: res.Message, icon: "warning" })
            }
          }
        })
        .catch((error) => {
          setLoading(false);
          console.log(error)
          SweetAlert.fire({ title: error, icon: "error" })
        })

    } catch (error) {
      SweetAlert.fire({ title: 'Error ocured while getting warranties or avalistes', icon: "error" })
    }

  }

  function loadCptMAD() {
    let codage = user.codage

    let search: ParamsPicklist = { CodeAgence: user.codage, Table: "AGENCE", Colonne1: "CODAGE", Colonne2: "cptmad", Colagence: '', Init: codage, Choix: 31 }
    setLoading(true)
    //form.resetFields()
    let config: any = {
      method: 'get',
      maxBodyLength: Infinity,
      url: Data.ApiUrl.AnySearch,
      headers: {
        'CypherSearch': Crypter.encrypt(JSON.stringify(search)),
        'Authorization': authHeader(),
        'Content-Type': 'application/json'
      },
    };
    axios.request(config)
      .then((response) => {
        setLoading(false);
        if (response.data) {
          const res = JSON.parse(Crypter.decrypt(response.data)).Value;
          //alert(JSON.stringify(res))

          console.log(res)
          if (res.StatutCode == 200) {
            localStorage.clear()

            console.log(res.Result.Table[0])

            form.setFieldValue("NUMCPT", res.Result.Table[0].cptmad)


            let search2: ParamsPicklist = { CodeAgence: user.codage, Table: "COMPTES", Colonne1: "NUMCPT", Colonne2: "NOMCPT", Colagence: '101', Init: res.Result.Table[0].cptmad, Choix: 31 }
            let config: any = {
              method: 'get',
              maxBodyLength: Infinity,
              url: Data.ApiUrl.AnySearch,
              headers: {
                'CypherSearch': Crypter.encrypt(JSON.stringify(search2)),
                'Authorization': authHeader(),
                'Content-Type': 'application/json'
              },
            };
            axios.request(config)
              .then((response) => {
                setLoading(false);
                if (response.data) {
                  const res = JSON.parse(Crypter.decrypt(response.data)).Value;
                  //console.log(res)
                  if (res.StatutCode == 200) {
                    localStorage.clear()

                    //console.log(res.Result.Table[0])

                    form.setFieldValue("lib_NUMCPT", res.Result.Table[0].NOMCPT)
                    form.setFieldValue("CDDEVS", res.Result.Table[0].CDDEVS)

                    form.setFieldValue("CODAGE", user.codage)
                    form.setFieldValue("lib_CODAGE", user.agence)
                    //setBranchSelected(true)
                  }
                  else {
                    SweetAlert.fire({ title: res.Message, icon: "warning" })
                  }
                }
                setLoading(false)
              })
              .catch((error) => {
                setLoading(false);
                console.log(error)
                SweetAlert.fire({ title: error, icon: "error" })
              });
          }
          else {
            SweetAlert.fire({ title: res.Message, icon: "warning" })
          }
        }
        setLoading(false)
      })
      .catch((error) => {
        setLoading(false);
        console.log(error)
        SweetAlert.fire({ title: error, icon: "error" })
      });


  }

  function consult() {
    setDataOpe({})

    let ref = form.getFieldValue("NUMRAP")

    form.resetFields()

    form.setFieldValue("NUMRAP", ref)
    let search: ParamsPicklist = { CodeAgence: user.codage, Table: "CBI", Colonne1: "NUMSEQ", Colonne2: "", Colagence: '101', Init: ref, Choix: 31 }
    //let data = Crypter.encrypt(form.getFieldValue("NUMSIMUL"));
    initialiazeButton()
    setLoading(true)
    //form.resetFields()
    let config: any = {
      method: 'get',
      maxBodyLength: Infinity,
      url: Data.ApiUrl.AnySearch,
      headers: {
        'CypherSearch': Crypter.encrypt(JSON.stringify(search)),
        'Authorization': authHeader(),
        'Content-Type': 'application/json'
      },
    };
    axios.request(config)
      .then((response) => {
        setLoading(false);
        if (response.data) {
          const res = JSON.parse(Crypter.decrypt(response.data)).Value;
          //alert(JSON.stringify(res))

          console.log(res)
          if (res.StatutCode == 200) {
            localStorage.clear()

            form.setFieldValue("CODOPE1", res.Result.Table[0].CDLBEC)

            if (res.Result.Table[0].CDLBEC == "950" || res.Result.Table[0].CDLBEC == "050") {
              res.Result.Table[0].CDLBEC = "950|050"
            }
            else if (res.Result.Table[0].CDLBEC == "951" || res.Result.Table[0].CDLBEC == "051") {
              res.Result.Table[0].CDLBEC = "951|051"
            }
            else if (res.Result.Table[0].CDLBEC == "955" || res.Result.Table[0].CDLBEC == "983") {
              res.Result.Table[0].CDLBEC = "955|955"
            }

            //console.log(res.Result.Table[0])

            setCodeOpe(res.Result.Table[0].CDLBEC)
            //form.setFieldsValue(res.Result.Table[0])
            form.setFieldValue("CODOPE", res.Result.Table[0].CDLBEC + "|load")

            //alert(res.Result.Table[0].AEGECE)

            form.setFieldValue("AEGECE", res.Result.Table[0].AEGECE)
            form.setFieldValue("NODECE", res.Result.Table[0].NODECE)
            form.setFieldValue("NUMSEQ", res.Result.Table[0].NUMSEQ)
            form.setFieldValue("DRNOSE", res.Result.Table[0].DRNOSE)
            form.setFieldValue("refOpe", res.Result.Table[0].NUMRAP)
            form.setFieldValue("SENSOP", res.Result.Table[0].SENSOP)
            // form.setFieldValue("NOMB01", res.Result.Table[0].NOMBO1)
            // form.setFieldValue("NOMB02", res.Result.Table[0].NOMBO2)
            // form.setFieldValue("NOMB03", res.Result.Table[0].NOMBO3)
            // form.setFieldValue("NOMB04", res.Result.Table[0].NOMBO4)
            // form.setFieldValue("NOMB05", res.Result.Table[0].NOMBO5)
            // form.setFieldValue("NOMB06", res.Result.Table[0].NOMBO6)
            // form.setFieldValue("NOMB07", res.Result.Table[0].NOMBO7)
            // form.setFieldValue("NOMB08", res.Result.Table[0].NOMBO8)
            // form.setFieldValue("NOMB09", res.Result.Table[0].NOMBO9)
            // form.setFieldValue("NOMB010", res.Result.Table[0].NOMBO10)
            // form.setFieldValue("NOMB011", res.Result.Table[0].NOMBO11)
            // form.setFieldValue("NOMB012", res.Result.Table[0].NOMBO12)
            // form.setFieldValue("NOMB013", res.Result.Table[0].NOMBO13)
            // form.setFieldValue("NOMB014", res.Result.Table[0].NOMBO14)
            // form.setFieldValue("NOMB015", res.Result.Table[0].NOMBO15)
            // form.setFieldValue("NOMB016", res.Result.Table[0].NOMBO16)
            // form.setFieldValue("NOMB017", res.Result.Table[0].NOMBO17)
            // form.setFieldValue("NOMB018", res.Result.Table[0].NOMBO18)
            // form.setFieldValue("NOMB019", res.Result.Table[0].NOMBO19)
            // form.setFieldValue("NOMB020", res.Result.Table[0].NOMBO20)
            form.setFieldValue("NUMCPT", res.Result.Table[0].numcptCli)
            form.setFieldValue("montantOpe", res.Result.Table[0].MONTAN)
            form.setFieldValue("DateOpe", ReformatDate(res.Result.Table[0].DATOPE))
            form.setFieldValue("OPECLI", res.Result.Table[0].OPECLI)

            form.setFieldValue("lib_CODOPE", res.Result.Table[0].LIBOPE)
            form.setFieldValue("nomClient", res.Result.Table[0].REMETT)
            //form.setFieldValue("TYPE", res.Result.Table[0].TYPE)
            //form.setFieldValue("LECEPC", res.Result.Table[0].LECEPC)
            form.setFieldValue("LITIGE", res.Result.Table[0].LITIGE)
            form.setFieldValue("UTISAI", res.Result.Table[0].UTISAI)
            form.setFieldValue("DATSAI", res.Result.Table[0].DATSAI)
            form.setFieldValue("TIME", res.Result.Table[0].TIME)
            form.setFieldValue("DEDEVR", res.Result.Table[0].DEDEVR)
            form.setFieldValue("UTIVAL", res.Result.Table[0].UTIVAL)
            form.setFieldValue("MONTDEV", res.Result.Table[0].MONTDEV)
            form.setFieldValue("TAUXDEV", res.Result.Table[0].TAUXDEV)
            form.setFieldValue("COMPTA", res.Result.Table[0].COMPTA)
            form.setFieldValue("LIGNE", res.Result.Table[0].LIGNE)
            form.setFieldValue("HOURSERV", res.Result.Table[0].HOURSERV)
            form.setFieldValue("MOIS", res.Result.Table[0].MOIS)
            form.setFieldValue("DATOPESYS", res.Result.Table[0].DATOPESYS)
            form.setFieldValue("DEDEVRSYS", res.Result.Table[0].DEDEVRSYS)
            form.setFieldValue("CNIClient", res.Result.Table[0].cniremet)
            form.setFieldValue("LieuDeliv", res.Result.Table[0].lieudelrem)
            form.setFieldValue("DateDeliv", ReformatDate(res.Result.Table[0].datdelrem))


            form.setFieldValue("dateheure", res.Result.Table[0].datdelrem)

            //alert((new Date(res.Result.Table[0].datdelrem).toLocaleDateString()))
            form.setFieldValue("uticonf", res.Result.Table[0].uticonf)
            form.setFieldValue("orderInfo", res.Result.Table[0].orderInfo)
            form.setFieldValue("coduti", res.Result.Table[0].coduti)
            form.setFieldValue("TelBenef", res.Result.Table[0].teleph)
            form.setFieldValue("ismes", res.Result.Table[0].ismes)
            form.setFieldValue("agccptCli", res.Result.Table[0].agccptCli)
            form.setFieldValue("numcptCli", res.Result.Table[0].numcptCli)
            form.setFieldValue("numcptLiai", res.Result.Table[0].numcptLiai)
            form.setFieldValue("SERCHQ", res.Result.Table[0].SERCHQ)

            let data = {
              "AEGECE": res.Result.Table[0].AEGECE,
              "NODECE": res.Result.Table[0].NODECE,
              "NUMSEQ": res.Result.Table[0].NUMSEQ,
              "DRNOSE": res.Result.Table[0].DRNOSE,
              "refOpe": res.Result.Table[0].NUMRAP,
              "SENSOP": res.Result.Table[0].SENSOP,
              // "NOMB01": res.Result.Table[0].NOMBO1,
              // "NOMB02": res.Result.Table[0].NOMBO2,
              // "NOMB03": res.Result.Table[0].NOMBO3,
              // "NOMB04": res.Result.Table[0].NOMBO4,
              // "NOMB05": res.Result.Table[0].NOMBO5,
              // "NOMB06": res.Result.Table[0].NOMBO6,
              // "NOMB07": res.Result.Table[0].NOMBO7,
              // "NOMB08": res.Result.Table[0].NOMBO8,
              // "NOMB09": res.Result.Table[0].NOMBO9,
              // "NOMB010": res.Result.Table[0].NOMBO10,
              // "NOMB011": res.Result.Table[0].NOMBO11,
              // "NOMB012": res.Result.Table[0].NOMBO12,
              // "NOMB013": res.Result.Table[0].NOMBO13,
              // "NOMB014": res.Result.Table[0].NOMBO14,
              // "NOMB015": res.Result.Table[0].NOMBO15,
              // "NOMB016": res.Result.Table[0].NOMBO16,
              // "NOMB017": res.Result.Table[0].NOMBO17,
              // "NOMB018": res.Result.Table[0].NOMBO18,
              // "NOMB019": res.Result.Table[0].NOMBO19,
              // "NOMB020": res.Result.Table[0].NOMBO20,
              "NUMCPT": res.Result.Table[0].numcptCli,
              "montantOpe": res.Result.Table[0].MONTAN,
              "DateOpe": ReformatDate(res.Result.Table[0].DATOPE),
              "OPECLI": res.Result.Table[0].OPECLI,
              "lib_CODOPE": res.Result.Table[0].LIBOPE,
              "nomClient": res.Result.Table[0].REMETT,
              "LITIGE": res.Result.Table[0].LITIGE,
              "UTISAI": res.Result.Table[0].UTISAI,
              "DATSAI": res.Result.Table[0].DATSAI,
              "TIME": res.Result.Table[0].TIME,
              "DEDEVR": res.Result.Table[0].DEDEVR,
              "UTIVAL": res.Result.Table[0].UTIVAL,
              "MONTDEV": res.Result.Table[0].MONTDEV,
              "TAUXDEV": res.Result.Table[0].TAUXDEV,
              "COMPTA": res.Result.Table[0].COMPTA,
              "LIGNE": res.Result.Table[0].LIGNE,
              "HOURSERV": res.Result.Table[0].HOURSERV,
              "MOIS": res.Result.Table[0].MOIS,
              "DATOPESYS": res.Result.Table[0].DATOPESYS,
              "DEDEVRSYS": res.Result.Table[0].DEDEVRSYS,
              "CNIClient": res.Result.Table[0].cniremet,
              "LieuDeliv": res.Result.Table[0].lieudelrem,
              "DateDeliv": ReformatDate(res.Result.Table[0].datdelrem),
              "dateheure": res.Result.Table[0].datdelrem,
              "uticonf": res.Result.Table[0].uticonf,
              "orderInfo": res.Result.Table[0].orderInfo,
              "coduti": res.Result.Table[0].coduti,
              "TelBenef": res.Result.Table[0].teleph,
              "ismes": res.Result.Table[0].ismes,
              "agccptCli": res.Result.Table[0].agccptCli,
              "numcptCli": res.Result.Table[0].numcptCli,
              "numcptLiai": res.Result.Table[0].numcptLiai,
              "SERCHQ": res.Result.Table[0].SERCHQ
            }

            setDataOpe(data)
            loadAccountInformations(res.Result.Table[0].numcptCli, data)

            if (res.Result.Table[0].CDLBEC == "955|955") {

              //alert(res.Result.Table[0].CDLBEC)
              //alert(ref)
              let search1: ParamsPicklist = { CodeAgence: user.codage, Table: "MAD", Colonne1: "REFMAD", Colonne2: "", Colagence: '101', Init: res.Result.Table[0].NUMRAP, Choix: 31 }
              let config1: any = {
                method: 'get',
                maxBodyLength: Infinity,
                url: Data.ApiUrl.AnySearch,
                headers: {
                  'CypherSearch': Crypter.encrypt(JSON.stringify(search1)),
                  'Authorization': authHeader(),
                  'Content-Type': 'application/json'
                },
              };
              axios.request(config1)
                .then((response) => {
                  setLoading(false);
                  if (response.data) {
                    const res1 = JSON.parse(Crypter.decrypt(response.data)).Value;
                    //alert(JSON.stringify(res))

                    ///console.log(res)
                    if (res1.StatutCode == 200) {
                      //console.log(res.Result.Table[0])

                      //form.setFieldsValue(res.Result.Table[0])
                      form.setFieldValue("NUMBORDEREAU", res1.Result.Table[0].NUMBORDEREAU)
                      form.setFieldValue("ORDREMAD", res1.Result.Table[0].ORDREMAD)
                      form.setFieldValue("REFMAD", res1.Result.Table[0].REFMAD)

                      form.setFieldValue("nombene", res1.Result.Table[0].NOMBENE)
                      form.setFieldValue("telbene", res1.Result.Table[0].TELBENE)
                      form.setFieldValue("cnibene", res1.Result.Table[0].CNIBENE)
                      setCodeSecret(res1.Result.Table[0].CODCONFIDENCE)

                      if (res1.Result.Table[0].CDETAT == "") {
                        setRecep(true)
                        setEnregActve(true)
                        setImpActive(false)
                        SweetAlert.fire({ title: "En attente de payement", icon: "success" })
                      } else {
                        SweetAlert.fire({ title: "Reception déjà effectuée", icon: "warning" })
                      }
                      loadCptMAD()
                    }
                    else {
                      SweetAlert.fire({ title: res.Message, icon: "warning" })
                    }
                  }
                  setLoading(false)
                })
                .catch((error) => {
                  setLoading(false);
                  console.log(error)
                  SweetAlert.fire({ title: error, icon: "error" })
                });
            }


            //res.Result.Table[0]


            //console.log(JSON.stringify(res.Result.Table))

            //initialiazeButton()

            //setConsulActive(false)

            //cunsultButton()

            setEnregActve(true)
            setImpActive(false)

            // chargement du billetage
            LoadBilletage({
              form: form,
              authHeader: authHeader(),
              user: user,
              Ref: res.Result.Table[0].NUMSEQ,
              ColRef: "RefOperation",
              Table: 'BilletageOperation'
            })

          }
          else {
            SweetAlert.fire({ title: res.Message, icon: "warning" })
          }
        }
        setLoading(false)
      })
      .catch((error) => {
        setLoading(false);
        console.log(error)
        SweetAlert.fire({ title: error, icon: "error" })
      });
  }

  setTimeout(() => {
    try {
      let reset = localStorage.getItem(Data.LocalVariable.Mainreset)
      if (reset == "1") {
        setSelectedRowKeys([])
        localStorage.removeItem(Data.LocalVariable.Mainreset)
      }
    }
    catch (error) { }
  }, .1)

  function loadAccountInformations(numcpt: string, dataOpeParam?: any) {
    setLoading(true)
    //var data = { CodeAgence: form.getFieldValue("CODAGE"), Table: "COMPTES", Colonne1: "NUMCPT", Colonne2: "NOMCPT", Colagence: form.getFieldValue("CODAGE"), Init: numcpt, choix: 33 }
    //alert(JSON.stringify(data))
    var config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: Datas.ApiUrl.GetCompte,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': authHeader(),
        'CypherNumCpte': Crypter.encrypt(numcpt)
      }
    };

    axios(config)
      .then((response) => {
        //alert('ok')
        if (response.data) {
          const res = JSON.parse(Crypter.decrypt(response.data));

          if (res.StatutCode == 200) {
            let datas = res.Result.Table;
            //form.setFieldsValue(datas[0])
            //console.log(datas[0])

            form.setFieldValue("AUTORI", formatNumber(datas[0].AUTORI))
            form.setFieldValue("BLOQUE", formatNumber(datas[0].BLOQUE))
            form.setFieldValue("DISPON", formatNumber(datas[0].DISPON))
            form.setFieldValue("CDDEVS", datas[0].CDDEVS)
            form.setFieldValue("CODAGE", datas[0].AGCCPT)
            form.setFieldValue("CDGESTCLI", datas[0].CDGESTCLI)

            form.setFieldValue("lib_CDDEVS", datas[0].lib_CDDEVS)
            form.setFieldValue("lib_CODAGE", datas[0].lib_AGCCPT)
            form.setFieldValue("lib_CDGESTCLI", datas[0].lib_CDGESTCLI)
            form.setFieldValue("lib_NUMCPT", datas[0].NOMCPT)
            form.setFieldValue("NUMCPT", datas[0].NUMCPT)

            setDataOpe({
              ...dataOpeParam,
              "CODAGE": datas[0].AGCCPT,
              "lib_CODAGE": datas[0].lib_AGCCPT,
              "lib_NUMCPT": datas[0].NOMCPT

            })


            //-----

          }
          else {
            SweetAlert.fire({ title: res.Message, icon: 'error' })
          }
        }
        setLoading(false);

      }).catch((error) => {
        //console.log(error)
        setLoading(false);
        // SweetAlert.fire({title: "Error", text : error})
      })
  }


  return (
    <div className='tab'>
      <Typography align='center' className='formTitle'><b>{window.location.pathname}</b></Typography>
      <Spin spinning={loading} size='large' style={{ color: 'green' }} >
        <Form autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" onFinish={onFinish} onFinishFailed={onFinishFailed} style={{ minWidth: 'auto', maxWidth: 'auto' }}>

          <div className='bG'>
            <legend><Typography color={"darkgreen"}>Actions</Typography></legend>
            <Form.Item shouldUpdate className='bouttong'>
              <Space direction="vertical" style={{ width: '100%' }}>
                {/* <Button size='large' className='bt_add' disabled={ajoutActve} onClick={SetStart} type="ghost" htmlType="button" block  >
                  Saisir
                </Button> */}
                <Button size='large' className='bt_add' disabled={consulActive} onClick={consult} type="ghost" htmlType="button" block  >
                  Rechercher
                </Button>

                <Button size='large' disabled={enregActve} className='bt_add' onSubmit={onFinish} type="ghost" htmlType="submit" block>
                  Enregistrer
                </Button>

                <Button

                  size='large'
                  className='bt_add'
                  disabled={impActive}
                  type="ghost"
                  htmlType="button"
                  onClick={() => {

                    handleDownloadRecu("pdf")
                  }}
                  block
                >
                  Aperçu
                </Button>

                <ReceptionAgent form={form} disabled={!recep} codeSecret={codeSecret} />
                {/* <Button size='large' className='bt_add' disabled={consulActive} onClick={consult} type="ghost" htmlType="button" block  >
                  Consulter
                </Button>
                <Button size='large' className='bt_add' disabled={enregActve} type="ghost" onClick={affiche} block>
                  Afficher
                </Button> */}
                {/* <Button size='large' className='bt_add' onClick={printTab} disabled={impActive} type="ghost" htmlType="button" block  >
                  Aperçu
                </Button> */}
                {/* <Button size='large' className='bt_add' disabled={modifActve} onClick={modif} type="ghost" htmlType="button" block  >
                  Modifier
                </Button> */}
                <Button size='large' onClick={handleAnulle} className='bt_add' type="ghost" block>
                  Annuler
                </Button>
              </Space>
            </Form.Item>
          </div>
          <div className='clientP'>
            <div>
              <Tabs size='small' type="card" defaultActiveKey="1" items={items} />
            </div>
            <div>
            </div>
          </div>
        </Form>
      </Spin>
    </div>
  );
}
export default VersementEspece;